/**
 * Created by user on bank bundle files implementation.
 */

class BankBundleFilesListViewController extends BaseTableViewController
{            
    static newInstance(): BankBundleFilesListViewController {
        let vc = new BankBundleFilesListViewController("bank-bundle-files-list-view");
        vc.initWithResource("layout/bank_bundle_files/BankBundleFilesListView.html");
        return vc;
    }

    viewDidLoad() {
        super.viewDidLoad();        

        // Setup search functionality
        this.searchTextField = MUIOutlet(this, "search-bar", "MUITextField");
        this.setupSearchTextField();

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.delegate = this;
        this.tableView.dataSource = this;        
        
        this.reloadData();
        // Setup add button
        // this.addButton.target = this;
        // this.addButton.action = "addButtonAction";
        
        // Setup filter button
        // this.filterButton.target = this;
        // this.filterButton.action = "filterButtonAction";
    }

    // MARK: - Actions

    addButtonAction(sender: any) {
        // Handle add new bank bundle file
        console.log("Add bank bundle file");
        // TODO: Implement file upload functionality
    }

    filterButtonAction(sender: any) {
        // Handle filter action
        console.log("Filter bank bundle files");
        // TODO: Implement filter functionality
    }

    // MARK: - Table View Data Source

    numberOfSections(tableview: UITableView): number {
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview: UITableView, section: number): number {
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    cellAtIndexPath(tableview: UITableView, indexPath: MIOIndexPath): BankBundleFileCell {
        let cell = tableview.dequeueReusableCellWithIdentifier("BankBundleFileCell") as BankBundleFileCell; 

        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as BankTransferBundleFile;
        cell.item = item;        

        cell.selected = (this.selectedItem?.identifier == item.identifier);

        return cell;
    }
    
    didSelectCellAtIndexPath(tableView: UITableView, indexPath: MIOIndexPath) {
        let obj = this.fetchedResultsController.objectAtIndexPath(indexPath);
        this.selectedItem = obj;
        this.showSelectedItemDetail();
    }

    private showSelectedItemDetail() {
        let vc = BankBundleFilesDetailViewController.newInstance();
        vc.item = this.selectedItem;

        this.splitViewController.showDetailViewController(vc);
    }

    // MARK: - Fetched Results Controller

    get fetchedResultsController(): MIOFetchedResultsController {
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        let ad = MUIWebApplication.sharedInstance().delegate;

        let predicates = [];
        if (this.searchString != null) {
            predicates.push( "(reference CONTAINS '" + this.searchString + "' OR concept CONTAINS '" + this.searchString + "')" );
        }

        let pf = predicates.length > 0 ? predicates.join(" AND ") : null;
        let sds = [MIOSortDescriptor.sortDescriptorWithKey("referenceDateString", false)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("BankTransferBundleFile", sds, pf);
        // fetchRequest.fetchLimit = 50;
        // fetchRequest.relationshipKeyPathsForPrefetching = ["bank"];
    
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }
}
